export default __webpack_public_path__ + "static/media/wellgrowerKo3.8000935f.svg";